<footer class="footer sm:footer-horizontal bg-neutral text-neutral-content items-center p-4">
  <aside class="brand-name grid-flow-col items-center">
    <img class="logo" src="img/logo/white-full.png" alt="logo"/>
    <p>Copyright © 2026 - All right reserved</p>
  </aside>
  <nav class="rs-container grid-flow-col gap-4 md:place-self-center md:justify-self-end">
    <a href="https://www.instagram.com/legend_binder/" class="icon-rs" title="Instagram">
      <i class="fa-brands fa-instagram"></i>
    </a>
    <a href="https://www.facebook.com/people/Legend-Binder/61588921773391/" class="icon-rs" title="facebook">
      <i class="fa-brands fa-facebook-f"></i>
    </a>
    <a href="https://www.tiktok.com/@legend_binder" class="icon-rs" title="TikTok">
      <i class="fa-brands fa-tiktok"></i>
    </a>
  </nav>
</footer>